var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShare = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.25 4c0-.966.784-1.75 1.75-1.75h1.5a.75.75 0 0 1 0 1.5H4a.25.25 0 0 0-.25.25v8c0 .138.112.25.25.25h8a.25.25 0 0 0 .25-.25v-1.5a.75.75 0 0 1 1.5 0V12A1.75 1.75 0 0 1 12 13.75H4A1.75 1.75 0 0 1 2.25 12V4z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 3.75a.75.75 0 0 1 0-1.5h4a.748.748 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V4.81L9.03 8.03a.75.75 0 0 1-1.06-1.06l3.22-3.22H9z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export default ForwardRef;